import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaIngresos = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "ingresos";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)

    const getData = async (anio,mes) => {
        setLoading(true);
        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data?.totalIngresos)}
                    </div>
                    <div style={styles.subtitulo}>
                        Ingresos
                    </div>
                </div>

                <div className="row">
                    {data?.ingresosFactura  > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(data?.ingresosFactura)}</strong>
                            </div>
                            <small style={styles.label}>Periodo Actual</small>
                        </div>
                    )}
                    {data?.ingresosRecibo > 0 && (
                        <div style={styles.infoBlock}>
                            <div>
                                <strong>{formatCurrency(data?.ingresosRecibo)}</strong>
                            </div>
                            <small style={styles.label}>Cuentas por Cobrar</small>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default TarjetaIngresos;
